import type { Offer } from '@repo/contracts/marketplace/offers/types';
import { isAmexOffer } from '@repo/contracts/marketplace/offers/utils';
import { aprDriverEmptyValueString } from '../../config/constants';
import type { StaticDrivers } from '../../model/types';

export function getStaticDrivers(
  creditCardOffer: Offer,
  _isLtoHighlightingEnabled: boolean,
): StaticDrivers {
  const {
    details: {
      signUpBonusDetails: { signUpBonusDetailsAnnotation },
      annualFee: { driverValue: annualFeeValue },
      apr: {
        ongoingRate: regularApr,
        introPurchases: purchaseIntroApr,
        introBalanceTransfers: balanceTransferIntroApr,
      },
      introOfferDetails: { offerString, tooltipString: introOfferTooltip, type },
      rewardRateDetails: { rateString, tooltipString: rewardsRateTooltip, rewardTypeDescription },
      balanceTransferFee,
      minimumDeposit,
    },
  } = creditCardOffer;
  const isInstitutionAmex = isAmexOffer(creditCardOffer);

  const showIntroOfferTooltip = type !== 'no rewards';
  const showIntroOfferDescription = signUpBonusDetailsAnnotation
    ? false
    : type !== 'cash' && type !== 'no rewards';

  return {
    annualFee: {
      id: 'annualFee',
      label: 'Annual fee',
      value: annualFeeValue || aprDriverEmptyValueString,
    },
    balanceTransferFee: {
      id: 'balanceTransferFee',
      label: 'Balance transfer fee',
      value: balanceTransferFee || aprDriverEmptyValueString,
    },
    rewardsRate: {
      id: 'rewardsRate',
      label: 'Rewards rate',
      value: rateString || aprDriverEmptyValueString,
      description: rewardTypeDescription,
      valueTooltip: rewardsRateTooltip,
    },
    introOffer: {
      id: 'introOffer',
      label: 'Intro offer',
      value: offerString || aprDriverEmptyValueString,
      description: showIntroOfferDescription ? type : undefined,
      valueTooltip: showIntroOfferTooltip ? introOfferTooltip : undefined,
    },
    purchaseIntroAPR: {
      id: 'purchaseIntroAPR',
      label: 'Purchase intro APR',
      value: purchaseIntroApr || aprDriverEmptyValueString,
    },
    balanceTransferIntroAPR: {
      id: 'balanceTransferIntroAPR',
      label: 'Balance transfer intro APR',
      value: balanceTransferIntroApr || aprDriverEmptyValueString,
    },
    regularAPR: {
      id: 'regularAPR',
      label: isInstitutionAmex ? 'APR' : 'Regular APR',
      value: regularApr || aprDriverEmptyValueString,
    },
    minimumDeposit: {
      id: 'minimumDeposit',
      label: 'Minimum deposit',
      value: minimumDeposit || aprDriverEmptyValueString,
    },
  };
}
